// extracted by mini-css-extract-plugin
export default {"wrapper":"calendarDay_wrapper__2xhlJ","day":"calendarDay_day__715jh","time":"calendarDay_time__Np6r9"};